import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class DropdownService {
  onGetItems: Subject<any> = new Subject<any>();
  onReturnedItems: Subject<any> = new Subject<any>();
  onExecAction: Subject<any> = new Subject<any>();

  constructor() {}

  getItems(values) {
    this.onGetItems.next(values);
  }

  returnedItems(values) {
    this.onReturnedItems.next(values);
  }

  execAction(values) {
    this.onExecAction.next(values);
  }
}
